import AccordionCore from '@studiometa/js-toolkit/components/Accordion';

/**
 * Accordion class.
 */
export default class Accordion extends AccordionCore {
  /**
   * Make sure `this.$children.AccordionItem` is an array.
   *
   * @returns {object}
   */
  get $children() {
    const $children = super.$children;

    if (!Array.isArray($children.AccordionItem)) {
      $children.AccordionItem = [];
    }

    return $children;
  }
}
